import { render } from "./otpPop.vue?vue&type=template&id=f8ea1568&scoped=true"
import script from "./otpPop.vue?vue&type=script&lang=js"
export * from "./otpPop.vue?vue&type=script&lang=js"

import "./otpPop.vue?vue&type=style&index=0&id=f8ea1568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ea1568"]])

export default __exports__